<template>
  <v-card variant="outlined" class="mt-3">
    <v-card-text>
      <div class="d-flex align-center justify-space-between mb-2">
        <span class="text-subtitle-1 font-weight-bold">
          {{ $t('routes.pod.authenticity.metadataAnalysis') }}
        </span>
        <span class="font-weight-bold" :style="{ color: scoreColor }">
          {{ metadataAnalysis.metadatascore }}%
        </span>
      </div>

      <div v-if="metadataAnalysis.metadataflags.length === 0" class="text-body-1 text-medium-emphasis">
        {{ $t('routes.pod.authenticity.metadataNoAnomalies') }}
      </div>

      <v-expansion-panels v-if="metadataAnalysis.metadataflags.length > 0" variant="accordion">
        <v-expansion-panel>
          <v-expansion-panel-title class="text-subtitle-1">
            {{ metadataAnalysis.metadataflags.length }}
            {{ metadataAnalysis.metadataflags.length === 1 ? 'anomaly' : 'anomalies' }}
            detected
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div
              v-for="(flag, index) in metadataAnalysis.metadataflags"
              :key="index"
              class="flag-row"
            >
              <div class="mt-1 mb-1">
                <v-chip
                  :color="severityColor(flag.severity)"
                  variant="flat"
                  size="x-small"
                >
                  {{ flag.severity }}
                </v-chip>
              </div>
              <div class="text-body-1 mt-1">
                {{ $localizeMessage(flag.description) }}
              </div>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AuthenticityMetadataScorecard',
  props: {
    metadataAnalysis: {
      type: Object,
      required: true,
    },
  },
  computed: {
    scoreColor() {
      const score = this.metadataAnalysis.metadatascore;
      if (score >= 80) return 'rgb(var(--v-theme-success))';
      if (score >= 50) return 'rgb(var(--v-theme-warning))';
      return 'rgb(var(--v-theme-error))';
    },
  },
  methods: {
    severityColor(severity) {
      switch (severity) {
        case 'HIGH': return 'error';
        case 'MEDIUM': return 'warning';
        case 'LOW': return 'info';
        default: return 'grey';
      }
    },
  },
};
</script>

<style scoped>
.flag-row {
  padding: 8px 0;
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.flag-row:last-child {
  border-bottom: none;
}
</style>
